import { getCacheBuster, poll } from 'api/shared';
import networkAdapter from '../adapters/network';

export const fetchAffiliateList = ({ userId }) => {
  const legacyOptions = {
    url: '/api/mycroft/v1/affiliates/',
    userId,
  };

  return networkAdapter({
    legacyOptions,
  });
};


export const fetchStatusSendScript = ({
  jobUuid,
  userId,
}: {
  jobUuid: string;
  userId: string;
}) => {
  return poll(() => {
    const legacyOptions = {
      url: `/api/mycroft/v2/prescriptions/push/${jobUuid}?bustCache=${getCacheBuster()}`,
      userId,
    };

    return networkAdapter({
      legacyOptions,
    });
  });
};


export const fetchJohnDeereFields = ({ userId }: { userId: string }) => {
  const legacyOptions = {
    url: '/api/deere/fields',
    userId,
    isPagedData: true,
  };

  return networkAdapter({
    legacyOptions,
  });
};

export const fetchJohnDeereWorkPlans = ({
  userId,
  scriptIds
}: {
    userId: string;
    scriptIds: string[];
  }) => {
  const legacyOptions = {
    url: '/api/deere/rx-work-plans-fetch',
    method: 'POST',
    userId,
    body: JSON.stringify({ rxIds: scriptIds }),
  };

  return networkAdapter({ legacyOptions });
};
